import { render, staticRenderFns } from "./LocalizedOptionSetFormInput.vue?vue&type=template&id=4659a0a0&scoped=true&"
import script from "./LocalizedOptionSetFormInput.vue?vue&type=script&lang=ts&"
export * from "./LocalizedOptionSetFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./LocalizedOptionSetFormInput.vue?vue&type=style&index=0&id=4659a0a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4659a0a0",
  null
  
)

export default component.exports